export default "__VITE_ASSET__Lrkk98mX__"